import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])])]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'COURIER_DEVICE_COUNT_ALL'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '100px'
      }, {
        prop: 'market_id',
        label: this.$t('market_mobile'),
        minWidth: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "table_market_id",
              "value": row.market_id,
              "custom": true
            }
          });
        }
      }, {
        prop: 'device_number',
        label: this.$t('device_number'),
        minWidth: '100px'
      }, {
        prop: 'courier_mobile',
        label: this.$t('courier_mobile'),
        minWidth: '140px'
      }, {
        prop: 'count_time',
        label: this.$t('count_time'),
        width: '200px'
      }, {
        prop: 'total',
        label: 'total',
        width: '200px'
      }, {
        prop: 'ctime',
        label: 'ctime',
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'uptime',
        label: 'uptime',
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      return function (_ref2) {
        var row = _ref2.row;
        return [//  ...this.p('edit', [{ icon: 'el-icon-edit-outline', action: () => this.edit(row.id) }], []),
          //  ...this.p('remove', [{ icon: 'el-icon-delete', type: 'danger', confirm: `确定删除吗`, action: () => this.delete(row.id) }], [])
        ];
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'count_style',
        label: this.$t('count_style'),
        default: 1,
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "count_style",
              "button": true
            },
            "model": {
              value: _this2.search.form.model.count_style,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "count_style", $$v);
              }
            }
          });
        }
      }, {
        prop: 'courier_user_phone',
        label: this.$t('courier_user_phone'),
        default: this.courier_user_phone,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.search.form.model.courier_user_phone,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "courier_user_phone", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_number',
        label: this.$t('device_number'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.search.form.model.device_number,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "device_number", $$v);
              }
            }
          });
        }
      }];
    },
    courier_user_phone: function courier_user_phone() {
      return this.$route.query.user_mobile;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'table_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  })
};